import { render, staticRenderFns } from "./CustomColorChip.vue?vue&type=template&id=571ba522&scoped=true"
import script from "./CustomColorChip.vue?vue&type=script&lang=js"
export * from "./CustomColorChip.vue?vue&type=script&lang=js"
import style0 from "./CustomColorChip.vue?vue&type=style&index=0&id=571ba522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571ba522",
  null
  
)

export default component.exports